import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormGroup,
  Grid,
  Link,
  makeStyles,
} from "@material-ui/core";

import { OrganisationDialogProps } from "../../OrganisationView/dialogs/DialogProps";
import { OrganisationChange } from "../../../domain/OrganisationChange";
import { ApprovalDialogItem } from "../../OrganisationView/dialogs/ApprovalDialogItem";
import { segmentList } from "@ofqual/portal-core/core/utils/listHelpers";
import React from "react";
import { approveRejectChange } from "../../../redux/actions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
  body: {
    marginTop: 5,
    marginBottom: 5,
  },
  actions: {
    textAlign: "right",
  },
  action: {
    display: "inline-block",
    marginLeft: 15,
    marginRight: 15,
    fontSize: "1em",
  },
  actionDivider: {
    display: "inline-block",
    color: theme.palette.primary.main,
  },
  formGroup: {
    "border-radius": "10px",
    border: "1px solid grey",
    padding: "5px",
    marginTop: "10px",
  },
}));

export const ApprovalDialog: React.FC<OrganisationDialogProps> = ({
  organisation,
  onClose,
  isAdmin,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleApproveReject = (
    changeId: string,
    orgId: string,
    isApprove: boolean
  ) => {
    dispatch(approveRejectChange(orgId, changeId, isApprove));
  };

  const orgChanges: OrganisationChange[] =
    organisation && organisation.organisationChanges;

  const segmentedChanges = segmentList(
    orgChanges.sort((a, b) =>
      a.correlationId && b.correlationId
        ? a.correlationId > b.correlationId
          ? 1
          : -1
        : 0
    ),
    (item) => item.correlationId || item.id
  );

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="approval-dialog"
    >
      <DialogTitle data-test="activity-title">
        Review pending changes
      </DialogTitle>
      <Divider component="div" />
      <DialogContent>
        Please accept or reject the following changes, the AO will be notified
        of your decision.
        <div className={classes.body}>
          {segmentedChanges.map((segment, index) => (
            <FormGroup
              key={index}
              className={
                segment.data.length > 1 ? classes.formGroup : undefined
              }
            >
              <div key={segment.label}>
                {segment.data.map((item) => (
                  <ApprovalDialogItem change={item} key={item.id} />
                ))}
                {isAdmin ? (
                  <Grid item md={12} className={classes.actions}>
                    <Link
                      data-test="accept-change"
                      component="button"
                      className={classes.action}
                      onClick={() =>
                        // pick the first item out the segmented list
                        // the api will action all in the group with the same correlationId
                        handleApproveReject(
                          segment.data[0].id,
                          segment.data[0].orgId,
                          true
                        )
                      }
                    >
                      Accept
                    </Link>
                    <span className={classes.actionDivider}>|</span>
                    <Link
                      data-test="reject-change"
                      component="button"
                      className={classes.action}
                      onClick={() =>
                        handleApproveReject(
                          segment.data[0].id,
                          segment.data[0].orgId,
                          false
                        )
                      }
                    >
                      Reject
                    </Link>
                  </Grid>
                ) : null}
              </div>
            </FormGroup>
          ))}
          {orgChanges.length ? null : (
            <strong>There are no changes left to approve</strong>
          )}
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Link
          component="button"
          onClick={onClose}
          data-test="close-review-pending-change-button"
        >
          Close
        </Link>
      </DialogActions>
    </Dialog>
  );
};
